// JB Hides the labels when the user starts typing in the input fields, the labels are acting as placeholders to include the red asterix

const inputFields = document.querySelectorAll('.contact .flex-col input');
const textarea = document.querySelector('#contact_textarea');
const textAreaLabel = document.querySelector('label[for="contact_textarea"]');

inputFields.forEach(function(field) {
    field.addEventListener('keyup', function() {
        if (field.value) {
            field.closest('.relative').querySelector('label').classList.add("max-lg:!hidden");
        } else {
            field.closest('.relative').querySelector('label').classList.remove("max-lg:!hidden");
          } 
    });
});

textarea.addEventListener('keyup', () => {
  if (textarea.value) {
    textAreaLabel.classList.add("max-lg:!hidden");
  } else {
    textAreaLabel.classList.remove("max-lg:!hidden");
  }
}); 